<p-dialog
	[visible]="visible"
	[modal]="true"
	[dismissableMask]="true"
	[closable]="false"
	[breakpoints]="CUE_DIALOG_BREAKPOINTS"
	[style]="{ width: '56vw' }"
	styleClass="cue-dialog"
	id="export-cue-dialog"
>
	<ng-template pTemplate="header">
		<div class="cue-header">
			<div class="cue-header__title">
				<i class="pi pi-send" aria-hidden="true"></i>
				<div>
					<span>Enviar cuaderno CUE</span>
					<small>Asistente de revisión y envío</small>
				</div>
			</div>

			<p-tag
				[value]="'Último envío: ' + ((flowFacade.statusCue?.fecha | date: 'dd/MM/yyyy') ?? 'Ninguno')"
				[severity]="'info'"
				class="cue-badge"
				[rounded]="true"
				[pTooltip]="statusHelp(flowFacade.statusCue?.estado)"
				tooltipPosition="bottom"
			></p-tag>
		</div>
	</ng-template>

	<div class="cue-body">
		<p-card class="cue-card">
			<div class="cue-assistant-intro">
				<h3>Revisa el cuaderno antes de enviarlo</h3>
				<p>Te mostramos solo lo importante. Los datos técnicos quedan guardados en detalles para soporte.</p>
			</div>

			<div class="cue-assistant-grid">
				<app-cue-main-status
					[statusCue]="flowFacade.statusCue"
					[showSpinner]="showSpinner"
				></app-cue-main-status>

				<app-cue-activity-summary [counter]="flowFacade.counter"></app-cue-activity-summary>

				<app-cue-user-warnings
					[warnings]="flowFacade.userWarnings"
					[hasPendingCue]="hasPendingCue()"
					[pendingTaskCount]="pendingTaskCount()"
				></app-cue-user-warnings>
			</div>

			<app-cue-retry-actions
				[statusCue]="flowFacade.statusCue"
				[hasPendingCue]="hasPendingCue()"
				[pendingTaskCount]="pendingTaskCount()"
				[showSpinner]="showSpinner"
				(retryCorrected)="retryCorrectedActivities()"
				(acceptedReviewRequested)="showAcceptedActivities()"
				(problemReviewRequested)="showProblemActivities()"
			></app-cue-retry-actions>

			@if (hasPendingCue()) {
				<div class="cue-pending">
					<p-message
						severity="warn"
						text="El cuaderno ya está enviado y pendiente de respuesta. Consulta la respuesta antes de crear otro envío."
						styleClass="mb-2"
					></p-message>

					<p-button
						type="button"
						label="Consultar resultado del envío"
						icon="pi pi-refresh"
						severity="info"
						[outlined]="true"
						[loading]="showSpinner"
						[disabled]="showSpinner"
						(onClick)="retryPendingCue()"
					></p-button>
				</div>
			}

			@if (showSpinner) {
				<div class="cue-spinner">
					<div class="cue-spinner__box">
						<p-progress-spinner strokeWidth="6" animationDuration="1.2s"></p-progress-spinner>
						<p>Consultando la respuesta del cuaderno...</p>
					</div>
				</div>
			}

			<app-cue-result-summary
				[messageState]="messageState"
				[importResult]="importResult"
			></app-cue-result-summary>

			<app-cue-history
				[cueHistory]="flowFacade.cueHistory"
				[reviewFilter]="historyReviewFilter"
			></app-cue-history>
		</p-card>
	</div>

	<ng-template pTemplate="footer">
		<div class="cue-footer-actions">
			<p-button
				type="button"
				[label]="closeButtonLabel"
				severity="secondary"
				[outlined]="true"
				[fluid]="true"
				(onClick)="close()"
			></p-button>

			<p-button
				type="button"
				[label]="sendButtonLabel"
				[loading]="showSpinner"
				[disabled]="!canSendCue()"
				severity="success"
				[fluid]="true"
				[pTooltip]="hasPendingCue() ? 'Consulta la respuesta pendiente antes de crear otro envío.' : ''"
				tooltipPosition="top"
				(onClick)="send()"
			></p-button>
		</div>
	</ng-template>
</p-dialog>
